import React, { Component, Fragment } from 'react'
import { Input, Button } from 'hljd'
import { observer } from 'mobx-react'
import Collapse from './Collapse'
import style from './style.module.less'
import { HeaderView } from '@merchant-backend/common-components'
import Store from './store'
import { Link } from 'react-router'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }
  componentDidMount() {
    this.store.getActionList()
    this.store.getCustomerList(true)
  }
  componentWillUnmount() {
    this.store.reset()
  }
  render() {
    const { title, changeField, pushCustomer } = this.store
    const header = [
      <Link to="/localMerchant/potentialCustomers">潜在客资</Link>,
      '新建推送'
    ]
    return (
      <HeaderView header={header} title="新建推送">
        <Fragment>
          <div className={style.hd}>
            <Input
              style={{ width: 96, height: 36 }}
              value={title}
              onChange={changeField('title')}
              maxLength={20}
            />
            <Button type="primary" onClick={pushCustomer}>
              发送
            </Button>
          </div>
          <Collapse store={this.store} />
        </Fragment>
      </HeaderView>
    )
  }
}
